import React, {useEffect, useState} from 'react'
import {createUseStyles, useTheme} from 'react-jss'
 
//eslint-disable-next-line
const styles = createUseStyles(theme => ({
 
}));
 
const AddressBookRouter = props => {
//eslint-disable-next-line
  const theme = useTheme();
//eslint-disable-next-line
  const classes = styles({...props, theme});
 
/***************** CONST ******************/
 
/***************** CONST ******************/
 
 
/***************** STATE ******************/
 
/***************** STATE ******************/
 
 
/***************** CALLBACK ******************/
 
/***************** CALLBACK ******************/
 
 
/***************** EFFECTS ******************/
 
/***************** EFFECTS ******************/
 
 
/***************** FUNCTIONS ******************/
 
/***************** FUNCTIONS ******************/
 
/***************** RENDER ******************/
  return (
	<div>
	  Address Book

	</div>
  )
 
/***************** RENDER ******************/
 
};
 
export default AddressBookRouter;